module.exports = __webpack_public_path__ + "static/linux-b9d85b8fa4e7d60895e56f82033a1d6e.png";